import React, { PureComponent } from 'react';
import styles from './index.css';
import copy from 'copy-to-clipboard';
import { wxShareTool } from '../../../utils/wxShareTool';
// @ts-ignore
const pageLoad3SecondsHandle = () => {
    if (typeof window === 'undefined')
        return false;
    let timer = null;
    console.log('pageLoad3SecondsHandle');
    timer = setInterval(function () {
        if (performance.now() >= 3000 && !(wxShareTool === null || wxShareTool === void 0 ? void 0 : wxShareTool.isShowAppIcon) && (wxShareTool === null || wxShareTool === void 0 ? void 0 : wxShareTool.isAndroid())) {
            wxShareTool.isShowAppIcon = true;
            wxShareTool.emit('showAppIcon');
            clearInterval(timer);
        }
        if ((wxShareTool === null || wxShareTool === void 0 ? void 0 : wxShareTool.isShowAppIcon) || !(wxShareTool === null || wxShareTool === void 0 ? void 0 : wxShareTool.isAndroid())) {
            clearInterval(timer);
        }
    }, 10);
};
pageLoad3SecondsHandle();
class WxLaunchApp extends PureComponent {
    constructor(props) {
        super(props);
        this.isSupport = () => {
            if (typeof window === 'undefined')
                return false;
            if (window.__ALink__)
                return false;
            // 适用微信版本要求为：7.0.12及以上。 系统版本要求为：iOS 10.3及以上、Android 5.0及以上。
            const UA = navigator.userAgent.toLocaleLowerCase();
            const isWechat = UA.includes('micromessenger') && !UA.includes('wxwork');
            const isAndroid = UA.includes('android');
            const isHmos = UA.includes('arkweb');
            let isSupportVersion = false;
            if (!isWechat)
                return false;
            const wechatVersionCollect = UA.match(/micromessenger\/([\d\.]+)/gi);
            const wechatVersion = (wechatVersionCollect &&
                wechatVersionCollect[0] &&
                wechatVersionCollect[0].replace('micromessenger/', '')) ||
                '';
            const androidVersionCollect = UA.match(/android [\d._]+/gi);
            const androidVersion = (androidVersionCollect && androidVersionCollect[0] && androidVersionCollect[0].replace('android ', '')) ||
                '';
            const iosVersionCollect = UA.match(/os [\d._]+/gi);
            const iosVersion = (iosVersionCollect &&
                iosVersionCollect[0] &&
                iosVersionCollect[0].replace('os ', '') &&
                iosVersionCollect[0].replace('os ', '').split('_') &&
                iosVersionCollect[0].replace('os ', '').split('_').join('.')) ||
                '';
            // 是否大于等于7.0.12
            if (wechatVersion &&
                (this.versionStringCompare(wechatVersion, '7.0.12') === 1 ||
                    this.versionStringCompare(wechatVersion, '7.0.12') === 0)) {
                isSupportVersion = true;
            }
            // 安卓
            if (isSupportVersion &&
                isAndroid &&
                androidVersion &&
                (this.versionStringCompare(androidVersion, '5.0') === 1 ||
                    this.versionStringCompare(androidVersion, '5.0') === 0)) {
                return true;
            }
            // IOS
            // if (
            //     isSupportVersion &&
            //     !isAndroid &&
            //     iosVersion &&
            //     (this.versionStringCompare(iosVersion, '10.3') === 1 || this.versionStringCompare(iosVersion, '10.3') === 0)
            // ) {
            //     return true;
            // }
            //  鸿蒙
            if (isSupportVersion &&
                isHmos) {
                return true;
            }
            return false;
        };
        this.versionStringCompare = (preVersion = '', lastVersion = '') => {
            const sources = preVersion.split('.');
            const dests = lastVersion.split('.');
            const maxL = Math.max(sources.length, dests.length);
            let result = 0;
            for (let i = 0; i < maxL; i++) {
                let preValue = sources.length > i ? sources[i] : 0;
                let preNum = isNaN(Number(preValue)) ? preValue.charCodeAt() : Number(preValue);
                let lastValue = dests.length > i ? dests[i] : 0;
                let lastNum = isNaN(Number(lastValue)) ? lastValue.charCodeAt() : Number(lastValue);
                if (preNum < lastNum) {
                    result = -1;
                    break;
                }
                else if (preNum > lastNum) {
                    result = 1;
                    break;
                }
            }
            return result;
        };
        this.getStyle = (obj, name) => {
            // @ts-ignore
            if (typeof window !== 'undefined' && window.getComputedStyle) {
                return getComputedStyle(obj, null)[name];
            }
            else {
                return obj.currentStyle[name];
            }
        };
        this.launchApp = React.createRef();
        this.launchAppBox = React.createRef();
    }
    componentDidMount() {
        const { launchAppSuccess, launchAppFail, launchAppClick, parentPosition = '', schemeLink = 'comifengnewsclient://call', } = this.props;
        const launchAppDom = this.launchApp.current;
        const launchAppBoxDom = this.launchAppBox.current;
        const UA = navigator.userAgent.toLocaleLowerCase();
        const isAndroid = UA.includes('android');
        if (launchAppDom) {
            launchAppDom.addEventListener('ready', () => {
                var _a, _b;
                if (!(wxShareTool === null || wxShareTool === void 0 ? void 0 : wxShareTool.isShowAppIcon) && ((_a = wxShareTool === null || wxShareTool === void 0 ? void 0 : wxShareTool.isAndroid) === null || _a === void 0 ? void 0 : _a.call(wxShareTool))) {
                    wxShareTool.emit('showAppIcon');
                    wxShareTool.isShowAppIcon = true;
                }
                if (!(wxShareTool === null || wxShareTool === void 0 ? void 0 : wxShareTool.isWxLaunchReady) && ((_b = wxShareTool === null || wxShareTool === void 0 ? void 0 : wxShareTool.isAndroid) === null || _b === void 0 ? void 0 : _b.call(wxShareTool))) {
                    wxShareTool.emit('wxLaunchReady');
                    console.log('触发wxLaunchReady事件');
                    wxShareTool.isWxLaunchReady = true;
                }
            });
            launchAppDom.addEventListener('launch', () => {
                if (launchAppSuccess) {
                    launchAppSuccess();
                }
                console.log('触发launchAppSuccess事件');
            });
            launchAppDom.addEventListener('error', () => {
                // 复制链接
                if (isAndroid) {
                    copy(schemeLink);
                }
                if (launchAppFail) {
                    launchAppFail();
                }
                console.log('触发launchAppFail事件');
            });
            launchAppDom.addEventListener('click', (e) => {
                if (launchAppClick) {
                    launchAppClick();
                }
                e.stopPropagation();
                console.log('触发launchAppClick事件');
                return false;
            });
        }
        if (launchAppBoxDom && launchAppBoxDom.parentElement) {
            const parentElementDom = launchAppBoxDom.parentElement;
            const parentElementPosition = this.getStyle(parentElementDom, 'position');
            if (parentElementPosition === 'static' || parentElementPosition === '') {
                if (parentPosition) {
                    parentElementDom.style.position = parentPosition;
                }
                else {
                    parentElementDom.style.position = 'relative';
                }
            }
        }
    }
    render() {
        let { schemeLink, appid, launchType = 'app' } = this.props;
        let opacity = '0';
        let background = 'none';
        if (launchType === 'app') {
            schemeLink = schemeLink || 'comifengnewsclient://call';
            appid = appid || 'wx8b2030599240f886';
        }
        if (launchType === 'weapp') {
            schemeLink = schemeLink || 'pages/index/index.html';
            appid = appid || 'gh_a25676e142f8';
        }
        if (typeof location !== 'undefined' && location.href.includes('launch=test')) {
            opacity = '1';
            background = 'red';
        }
        return this.isSupport() ? (React.createElement("div", { className: styles.wxLaunchAppBox, ref: this.launchAppBox },
            launchType === 'app' && (React.createElement("wx-open-launch-app", { ref: this.launchApp, appid: appid, extinfo: schemeLink },
                React.createElement("script", { type: "text/wxtag-template" },
                    React.createElement("div", { style: { width: '2000px', height: '2000px', opacity, background } }, "wx-open-launch-app")))),
            launchType === 'weapp' && (React.createElement("wx-open-launch-weapp", { ref: this.launchApp, username: appid, path: schemeLink },
                React.createElement("script", { type: "text/wxtag-template" },
                    React.createElement("div", { style: { width: '2000px', height: '2000px', opacity, background } }, "wx-open-launch-weapp")))))) : ('');
    }
}
export default WxLaunchApp;
